// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rNNG","placeholdersHeader":"styles_placeholdersHeader__VgDaf","editorStyle":"styles_editorStyle__BuSz4","placeholdersBox":"styles_placeholdersBox__3DSzM"};